/* eslint-disable no-unused-vars */

import React, { useEffect } from 'react'
import Header from "../../Layout/Header"
import Footer from "../../Layout/Footer"
import CompiledChangeLevel from './CompiledChangeLevel'
import { useLocation } from 'react-router-dom'
import { CommonPageData } from '../../../styles/common.style';

const ChangeLevel = () => {
  const location = useLocation()
  const { exercise } = location?.state
  // const { activeDayId } = location.state
  const { programId } = location?.state
  const { redirectLink } = location?.state

  const compilationVideoId = exercise && exercise?.compilation_video_id ? exercise?.compilation_video_id : null

  return (
    <div>

      <Header />

      {compilationVideoId ? (

        <CompiledChangeLevel
          exerciseId={exercise?.exercise_id}
          curLevel={exercise?.exerciseLevel?.level?.id}
          activeId={exercise?.id}
          programId={programId}
          redirectLink={redirectLink}
          compilationVideoId={compilationVideoId}
        />
      ) : (
        <>
          <CommonPageData>
            <div className='common-banner-block'>
              <div className='main-banner'>
                <img src='/images/banner-common-block.png' alt='img' />
              </div>
              <div className='container'>
                <div className='common-banner-block-inner'>
                  <h1>Change Movement</h1>
                </div>
              </div>
            </div>
            <div className='common-banner-block '>
              {/* <div className='main-banner'>
                <img src='/images/banner-common-block.png' alt='img' />
              </div> */}
              <div className='container '>
                {/* <div className='common-banner-block-inner'>
                  <h1>Change Movement</h1>
                </div> */}
                <>
                  <div className='middle-text-block text-center mt-5 mb-5'>
                    <h4>
                      There are no replacement options for this exercise
                    </h4>
                  </div>
                </>
              </div>
            </div>

          </CommonPageData>
        </>
      )}

      <Footer />
    </div>
  )
}

export default ChangeLevel